import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
import { Subscription } from 'rxjs';

import { UpgradedFormGroup } from './details-overlay.model';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[spFormErrorMsg]',
  standalone: false,
})
export class FormErrorMessageDirective implements OnInit, OnDestroy {
  @Input() spFormErrorMsg: UpgradedFormGroup;
  @Input() multipleMessages = false;
  private formChangesSub: Subscription;
  groupErrorMessages = {
    invalidSpaceSize: 'overlayDetails.invalidSpaceSize',
    invalidDates: 'overlayDetails.invalidDates',
    invalidVacancyAvailDate: 'overlayDetails.invalidVacancyAvailDate',
    invalidTenancyStatus: 'overlayDetails.invalidTenancyStatus',
  };
  constructor(
    private el: ElementRef,
    private translationService: L10nTranslationService,
    private render: Renderer2,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    /**
     ** "changeDetection" is not being triggered on this directive due to data on @Input() being an Object
     ** the form validation will be performed when value change on the form itself.
     * */
    this.formChangesSub = this.spFormErrorMsg.valueChanges.subscribe(() => {
      if (this.multipleMessages) {
        return this.checkErrorMessages();
      }
      this.checkErrorMessage();
    });
  }

  ngOnDestroy(): void {
    this.formChangesSub.unsubscribe();
  }

  private checkErrorMessage() {
    if (this.spFormErrorMsg?.dirty) {
      // * Grab error & warning values from...
      const errors = this.spFormErrorMsg.errors || {};
      const warnings = this.spFormErrorMsg.warnings || {};
      // * Take first error from the stack...
      const errorOnTop = Object.keys({ ...errors, ...warnings })[0];
      const label =
        errorOnTop && this.groupErrorMessages[errorOnTop]
          ? this.translationService.translate(this.groupErrorMessages[errorOnTop])
          : '';
      const labelColor = Object.keys(errors).length ? 'red' : Object.keys(warnings).length ? 'orange' : '';
      // * Display error message on html...
      const labelColorSanitized = this.sanitizer.sanitize(SecurityContext.NONE, labelColor) ?? '';
      this.el.nativeElement.style.color = labelColorSanitized;

      const sanitizedLabel = this.sanitizer.sanitize(SecurityContext.NONE, label) ?? '';
      this.el.nativeElement.innerText = sanitizedLabel;
    }
  }

  private checkErrorMessages() {
    this.el.nativeElement.innerHTML = '';
    const errors = this.spFormErrorMsg.errors || {};
    const warnings = this.spFormErrorMsg.warnings || {};
    const errorElemets = this.createLiElements(Object.keys(errors), true);
    const warningElements = this.createLiElements(Object.keys(warnings), false);
    [...errorElemets, ...warningElements].forEach(eachEle => {
      this.el.nativeElement.appendChild(eachEle);
    });
  }

  private createLiElements(messages: string[], isError: boolean) {
    return (messages ?? []).map(msg => {
      const label =
        msg && this.groupErrorMessages[msg] ? this.translationService.translate(this.groupErrorMessages[msg]) : '';
      const labelColor = isError ? 'red' : 'orange';
      const perElement = this.render.createElement('span');
      perElement.style.color = labelColor;
      perElement.innerText = label;
      return perElement;
    });
  }
}
